import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ModalController, Modal } from 'ionic-angular';
import { Items } from '../../providers/providers';
import { UserAccount } from '../../models/account';
import { Client } from '../../models/client';
import { User } from '../../providers/user';
import { Practice } from '../../models/practice';
import { UserData } from '../../models/user';

/**
 * Generated class for the AccountPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'account',
  segment: 'account',
})
@Component({
  selector: 'page-account',
  templateUrl: 'account.html',
})
export class AccountPage {

  text: string;
  isPlanSelected: boolean;
  isAccountSelected: boolean;
  isFeedbackSelected: boolean;
  isHelpSelected: boolean;
  isUsersSelected: boolean;
  isGroupingSelected: boolean;
  accountData: UserAccount;
  practiceDetails: any;
  practice: any;
  userData: UserData;
  isMasterUser: boolean;
  isSupervisor: boolean;
  isPractitioner: boolean;
  page_search: string = '';
  menu_search: string = '';
  show_result: boolean = false;
  displayList: Client[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
    public items: Items, public modalCtrl: ModalController, public user: User) {

    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    if (this.userData.usertype_id === "1") {
      this.isMasterUser = true;
      this.text = 'account';
      // this.isPlanSelected = true;
    } else {
      this.text = 'account';
      // this.isAccountSelected = true;
    }
    this.isAccountSelected = true;
    if (this.userData.usertype_id === "2") {
      this.isSupervisor = true;
    }
    if (this.userData.usertype_id === "3") {
      this.isPractitioner = true;
    }
    
  }

  ionViewDidLoad() {
  }

  ionViewWillEnter() {

  }

  makeAccountPayment(userAccount) {
    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.accountData = res;
        localStorage.setItem('accountData', JSON.stringify(res));
        let modal = this.modalCtrl.create('payment', null, { cssClass: "my-modal" });
        modal.present();
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  planSelected(item) {
    this.text = item;
    this.isPlanSelected = true;
    this.isAccountSelected = false;
    this.isFeedbackSelected = false;
    this.isHelpSelected = false;
    this.isUsersSelected = false;
    this.isGroupingSelected = false;
  }

  accountSelected(item) {
    this.text = item;
    this.isAccountSelected = true;
    this.isFeedbackSelected = false;
    this.isHelpSelected = false;
    this.isPlanSelected = false;
    this.isUsersSelected = false;
    this.isGroupingSelected = false;
  }

  feedbackSelected(item) {
    this.text = item;
    this.isFeedbackSelected = true;
    this.isPlanSelected = false;
    this.isHelpSelected = false;
    this.isAccountSelected = false;
    this.isUsersSelected = false;
    this.isGroupingSelected = false;
  }

  helpSelected(item) {
    this.text = item;
    this.isHelpSelected = true;
    this.isFeedbackSelected = false;
    this.isPlanSelected = false;
    this.isAccountSelected = false;
    this.isUsersSelected = false;
    this.isGroupingSelected = false;
  }
  usersSelected(item) {
    this.user.getPractices().subscribe(res => {
      if (res) {
        this.practice = res;
        this.text = item;
        this.isUsersSelected = true;
        this.isHelpSelected = false;
        this.isFeedbackSelected = false;
        this.isPlanSelected = false;
        this.isAccountSelected = false;
        this.isGroupingSelected = false;
      }
    },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  groupingSelected(item) {
    this.text = item;
    this.isHelpSelected = false;
    this.isFeedbackSelected = false;
    this.isPlanSelected = false;
    this.isAccountSelected = false;
    this.isUsersSelected = false;
    this.isGroupingSelected = true;
  }

  /* same as makeAccountPaymentMethod because of the event emitter
  */
  usersTabSelected(practice) {
    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.accountData = res;
        localStorage.setItem('accountData', JSON.stringify(res));
        let modal = this.modalCtrl.create('payment', null, { cssClass: "my-modal" });
        modal.present();
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  goToClientsPage() {
    this.navCtrl.push('clients');
  }

  goToHomePage() {
    this.navCtrl.push('home');
  }

  goToAssessmentsPage() {
    this.navCtrl.push('assessments');
  }

  goToInsightPage() {
    this.navCtrl.push('redirect-insights');
  }

  goToAccountsPage() {
    this.navCtrl.push('account');
  }

  selectClient(item) {
    this.navCtrl.push('clients', { clientId: item.id, client: item })

  }

  onInput() {
    var menu_search = this.menu_search.trim()

    if (menu_search.length < 3) {
      this.displayList = [];
      this.show_result = false;
    } else {      
      this.items.getClientSmallList(this.menu_search).subscribe(res => {
        if (res) {
          this.displayList = res;
          this.show_result = true;
          return this.displayList;
          }
      }, err => {
        console.error('ERROR', err);
      });
    }    
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts